/**
 * The error message to be logged when trying to access `getContext` api while browser context does not exist.
 * @type {String}
 */
export const CONTEXT_DOES_NOT_EXIST =
    'Browser context does not exist, please ensure the run time owner sets one on the window scope before using this API';
